import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CommonService } from '../../common.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
declare var $: any;
@Component({
  selector: 'app-addspeciesmanagement',
  templateUrl: './addspeciesmanagement.component.html',
  styleUrls: ['./addspeciesmanagement.component.css']
})
export class AddspeciesmanagementComponent implements OnInit {
  upperlimit: any = '';
  upperlimit2: any = '';
  upperlimit1: any = '';
  returnUrl = "/dashboard/speciesmanagement";
  addSpeciesFormValue: any;
  getspeciesvalue: any;
  addUrl: any;
  addvalue1
  geturl: any;
  registerForm: FormGroup;
  submitted = false;
  getlistApi: any;
  loginresponse: any;
  languages: any;
  selectallvalue: any;
  userrole: any;
  getval: number;
  hiben: any = '';
  farm_userrole: any;
  getfarmsListData: any = [];
  selectAllText = true;
  getspecieseditApi: any;
  isDone: any;
  isDisabled: boolean = false;
  age_group_getval: any;
  selectedmultidata: any;
  varfirstarr: any = [];
  varsecondarr: any;
  varageval: any;
  isLoading: boolean = false;
  cby_mby: any;

  constructor(private router: Router, private commonService: CommonService, private formBuilder: FormBuilder) { }

  async ngOnInit() {
    this.isLoading = true;
    this.loginresponse = JSON.parse(sessionStorage.getItem('userrole'));
    this.userrole = this.loginresponse.read_status;
    this.farm_userrole = this.loginresponse.user_farm_id;
    this.cby_mby = this.loginresponse.user_id;
    if (this.farm_userrole) {
      $("#farmname").attr("disabled", "disabled")

    }

    $('.status .form-control').selectpicker();
    this.registerForm = this.formBuilder.group({
      speciesid: ['', Validators.required],
      speciesName: ['', Validators.required]
      // status: ['', Validators.required]
    });

    this.getlistApi = "/farms";
    (await this.commonService.getApi(this.getlistApi)).subscribe(
      (res) => {
        console.log(this.farm_userrole)
        this.getfarmsListData = res.data;
        console.log('data', this.getfarmsListData)
        /*$.each(this.getfarmsListData, function(key, value) {
          $('#farmname').append($('<option>', {
              value: value.tnfr_id,
              text:value.tnfr_name
          }))
          
        });*/
        setTimeout(() => {
          $(function () {
            $('#farmname').multiselect({
              selectedText: "# of # selected",
              includeSelectAllOption: true,
              buttonText: function (options) {
                if (options.length == 0) {
                  return ' None selected ';
                } else {
                  var selected = 0;
                  options.each(function () {
                    selected += 1;
                  });
                  return selected + ' Selected ';
                }
              },
              enableFiltering: true,
              enableCaseInsensitiveFiltering: true,
              filterPlaceholder: 'Search for something...',
              onChange: function (option, checked, select) {
                this.selectedmultidata = $('#farmname').val();
                console.log(this.selectedmultidata);

              }

            });
          });
          this.isLoading = false;
        },);

        //farm user role based view
        if (this.farm_userrole) {
          setTimeout(() => {
            var optionVal = this.farm_userrole;
            console.log(this.farm_userrole);
            $("#farmname").find("option[value=" + optionVal + "]").prop("selected", "selected");
          }, 500);
          setTimeout(() => {
            $("#farmname").multiselect('refresh');
          }, 1000);
          // refresh the selectpicker with fetched courses  
        }
      })
  }

  statusupdate() {
    $('.addspeciesfak').dropdown('toggle');
  }

  addspeciesfak
  get f() { return this.registerForm.controls; }
  onSubmit() {
    this.submitted = true;
    // stop here if form is invalid
    if (this.registerForm.invalid) {
      return;
    }
    // display form values on success
    this.speciesmanagement()
  }
  getSelectedOptions(e) {
    alert(e)
  }
  getinputvalue(e) {
    console.log(e.target.value)
    var value1 = parseInt("1") + parseInt(e.target.value);
    this.upperlimit = isNaN(value1) ? '' : value1;
  }
  getinputvalue2(e) {
    console.log(e.target.value)
    var value1 = parseInt("1") + parseInt(e.target.value);
    this.upperlimit1 = isNaN(value1) ? '' : value1;
    //this.hiben=isNaN(value1) ? '' : 'NaN';
  }
  getinputvalue3(e) {
    console.log(e.target.value)
    var value1 = parseInt("1") + parseInt(e.target.value);
    this.upperlimit2 = isNaN(value1) ? '' : value1;
  }
  createagegrouprow() {
    this.isDone = 1;
    this.isDisabled = true;
    console.log("work")
  }
  modelpopupgetdata() {
    if (this.varfirstarr.length === 0) {
      this.varsecondarr = [];
      var obj = {
        "name": $("#Name").val(),
        "status": $("#statusage").val(),
        "time_range": 0 + "-" + $("#timerange").val()
      };
      this.varfirstarr.push(obj);
      this.varsecondarr.push(obj);
    } else {
      var timerange = this.varsecondarr[0].time_range;
      this.varsecondarr = [];
      var splitedval = timerange.split('-');
      console.log(splitedval[1])
      var getval = splitedval[1];
      var addone = "1";
      var sum = parseInt(getval) + parseInt(addone);
      console.log(sum);
      var obj = {
        "name": $("#Name").val(),
        "status": $("#statusage").val(),
        "time_range": sum + "-" + $("#timerange").val()
      };
      this.varfirstarr.push(obj);
      this.varsecondarr.push(obj);
    }
    console.log(this.varfirstarr);
    alert("Age group data added successfully")
    this.age_group_getval = this.varfirstarr
  }

  async speciesmanagement() {
    var finalvalue = [];
    var agegroupName1 = $("#agegroupName1").val();
    var agegroup1limit = $("#lowerlimit1").val() + '-' + $("#upperlimit1").val();
    var agegroup1object = { name: agegroupName1, time_range: agegroup1limit }
    finalvalue.push(agegroup1object);
    var agegroupName2 = $("#agegroupName2").val();
    var secup = $("#upperlimit2").val()
    var secondupperlimit = (secup) ? secup : 'n';
    var agegroup2limit = $("#lowerlimit2").val() + '-' + secondupperlimit;
    if (agegroupName2) {
      var agegroup2object = { name: agegroupName2, time_range: agegroup2limit }
      finalvalue.push(agegroup2object);
    }
    var agegroupName3 = $("#agegroupName3").val();
    var thirdup = $("#upperlimit3").val()
    var thirdupperlimit = (thirdup) ? thirdup : 'n';
    var agegroup3limit = $("#lowerlimit3").val() + '-' + thirdupperlimit;
    if (agegroupName3) {
      var agegroup3object = { name: agegroupName3, time_range: agegroup3limit }
      finalvalue.push(agegroup3object);
    }
    var agegroupName4 = $("#agegroupName4").val();
    var fourthup = $("#upperlimit4").val()
    var fourthupperlimit = (fourthup) ? fourthup : 'n';
    var agegroup4limit = $("#lowerlimit4").val() + '-' + fourthupperlimit;
    if (agegroupName4) {
      var agegroup4object = { name: agegroupName4, time_range: agegroup4limit }
      finalvalue.push(agegroup4object);
    }
    console.log(finalvalue);
    var selectedmultidata = $('#farmname').val();
    console.log(selectedmultidata);
    let myArray = selectedmultidata.toString();
    console.log(myArray);

    this.addSpeciesFormValue = {
      "name": $("#speciesName").val(),
      "speciesID": $("#speciesid").val(),
      "farm_id": myArray,
      "status": $("#status").val(),
      "cby": 1,
      "age_group": finalvalue
    };
    console.log(this.addSpeciesFormValue)
    this.addUrl = "/species";
    (await this.commonService.postApi(this.addUrl, this.addSpeciesFormValue)).subscribe(
      data => {
        alert("Data added successfully");
      });

    setTimeout(
      (): void => {

        this.router.navigate([this.returnUrl]);

      },
      500
    );

  }
  openmodelpopup() {
    $('.selectpicker').selectpicker('refresh');
    $("#myModal").modal("toggle");
  }

  backnavigate() {
    //model popup close

    //model popup end
    this.router.navigate([this.returnUrl]);
  }
}
